import { Navbar as NavbarMantine, Text } from "@mantine/core";
import { useSelector } from "react-redux";

// utils
// import Logo from '../../assets/logo/logo-title-right-filled.svg';
import MainLinks from "./_MainLinks";

export default function Navbar() {
  const navListOpen = useSelector((state) => state.theme.navListOpen);

  return (
    <NavbarMantine
      p="md"
      hiddenBreakpoint="sm"
      hidden={!navListOpen}
      width={{ sm: 160, lg: 160 }}
    >
      <NavbarMantine.Section grow mt="md">
        <MainLinks />
      </NavbarMantine.Section>
      <NavbarMantine.Section>
        <Text size="xs">
          Made with <span style={{}}>❤</span> by &copy; Qaflab Tech Team{" "}
          {new Date().getFullYear()}
        </Text>
      </NavbarMantine.Section>
    </NavbarMantine>
  );
}
